module.exports = __webpack_public_path__ + "static/media/logoWithName.7da0e4a7.svg";